import { render, staticRenderFns } from "./RegionsComponent.vue?vue&type=template&id=67334e12&scoped=true"
import script from "./RegionsComponent.vue?vue&type=script&lang=js"
export * from "./RegionsComponent.vue?vue&type=script&lang=js"
import style0 from "./RegionsComponent.vue?vue&type=style&index=0&id=67334e12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67334e12",
  null
  
)

export default component.exports